import { getMetaDataAll } from '@/services/metadata';
import { useEffect, useState } from 'react';

export default () => {
  const [metadata, setMetadata] = useState<any>();

  useEffect(() => {
    (async () => {
      const res = await getMetaDataAll();
      if (res.success) {
        setMetadata(res.data);
      }
    })();
  }, []);

  return { metadata };
};
